import paymentTokens from '../../functions/paymentTokens.js';
export const { DONATION_TOKENS } = paymentTokens;

export const DONATION_TOKENS_BY_SYMBOL = DONATION_TOKENS.reduce((acc, token) => {
    acc[token.symbol] = token;
    return acc;
}, {});

export const resolveDonationToken = (symbol) =>
    DONATION_TOKENS_BY_SYMBOL[symbol] || DONATION_TOKENS_BY_SYMBOL.SOL;
